"use strict";

/**
* Класс для числовых реквизитов.
* 
* @class WebAccess.components.wrappers.form.requisites.Integer
* @extends WebAccess.components.wrappers.form.requisites.Text
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {object} data Данные для инициализации реквизита
* @since 5.0.0.7100
*/
(function (global) {

  /**
  * @inner
  */
  var onControlInitComplete = function (jControl, callback) {
    if (jControl.hasClass('inited') || (jControl.hasClass('rs_InitComplete') && jControl.hasClass('rs_custom'))) {
      callback();
    } else {
      jControl.bind('Init', function () {
        callback();
      });
    }
  };

  var Integer = global.WA.CMP.wrappers.form.requisites.Text.extend({
    className: "Integer",

    /**
    * @private 
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindControlEvents
    * @since 5.0.0.7100
    */
    _bindControlEvents: function (jControl) {
      var me = this;
      var controlInit = $.Deferred();
      me._allControlsInit.push(controlInit);

      me._super(jControl);

      onControlInitComplete(jControl, function () {
        controlInit.resolve();
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    getValue: function (opt_jControl) {
      if (this._data && this._data.isRendered === false) return this._data.value;
      var jControl = opt_jControl || this.controls[0];
      var jControlValue = jControl.val();
      if (typeof jControl.data('autoNumeric') === 'object' && jControlValue !== '*') {
        return jControl.autoNumeric('get');
      }
      return (!jControlValue) ? null : jControlValue;
    },

    setValue: function (value, opt_displayValue, opt_needTriggerResult) {      
      var me = this;
      if (_.isUndefined(value)) return this;
      opt_needTriggerResult = (opt_needTriggerResult !== false); //если не передан, то по умолчанию будет true.

      if (this.controls.length === 0) return this._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);
      
      value = (value+"").replace(',', '.');
  
      var val = parseFloat(value);

      var jControl;
      for (var i = 0; i < this.controls.length; i++) {
        jControl = this.controls[i];

        if (value === '*') {
          jControl.val('*');
        } else {
          if ((value === '' || _.isNull(value) || isNaN(val))) {
            jControl.val('');
            jControl.removeAttr("title");
            continue;
          }

          if (typeof jControl.data('autoNumeric') === 'object') {
            jControl.autoNumeric('set', val);
          } else {
            jControl.val(val);
          }
        }

        if (opt_displayValue) {
          jControl.attr("title", opt_displayValue);
        } else {
          jControl.removeAttr('title');
        }
        if (opt_needTriggerResult) { jControl.change(); }
      };

      this.touch();
      return this;
    }

  });

  global.WA.CMP.wrappers.form.requisites.Integer = Integer;
})(window);


